import { Component, OnInit, Input, ViewChild, ElementRef, QueryList, AfterViewInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomConfirmDialogService } from 'src/app/services/Non-Master/CustomConfirmDialog.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { tItemService } from 'src/app/services/tItem.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { tDishesModel } from 'src/app/models/tDishesModel';
import { FormControl } from '@angular/forms';
import { EnglishDefaultModel, ChineseDefaultModel, SystemDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { AppComponent } from 'src/app/app.component';
import { tPackageModel } from 'src/app/models/tPackageModel';
import { tPackageService } from 'src/app/services/tPackage.service';
import { tItemCateModel } from 'src/app/models/tItemCateModel';
import { tItemCateService } from 'src/app/services/tItemCate.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { UnitItemService } from 'src/app/services/Unit/UnitItem.service';
import { UnitItemModel } from 'src/app/models/UnitItemModel';

@Component({
  selector: 'app-dishes-search-dialog',
  templateUrl: './dishes-search-dialog.component.html',
  styleUrls: ['./dishes-search-dialog.component.css']
})
export class DishesSearchDialogComponent implements OnInit {

  selectedRowIndex: number = -1;

  itemUnitList: UnitItemModel[];

  constructor(public activeModal: NgbActiveModal,
    private router: Router,
    private customConfirmDialogService: CustomConfirmDialogService,
    private log: LoggerService,
    private route: ActivatedRoute,
    private tItemService: tItemService,
    private tPackageService: tPackageService,
    private tItemCateService: tItemCateService,
    private el: ElementRef,
    private unitItemService: UnitItemService

  ) {

  }

  searchFilterControl = new FormControl();
  searchPackageFilterControl = new FormControl();


  displayedColumns: string[] = [
    'ID',
    'dishesDesc',
    'unitDesc'
  ];



  dataSource: MatTableDataSource<tDishesModel>;
 // dataSource_package: MatTableDataSource<tPackageModel>;

  dataList: tDishesModel[];
 // dataList_package: tPackageModel[];

 // itemCateList: tItemCateModel[];
 dishesCatList=[
  {id:4,desc:"粥餐"},
  {id:1,desc:"早餐"},
  {id:2,desc:"午餐"},
  {id:3,desc:"晚餐"},
  
];
  // itemDescFilter = new FormControl();
  // itemCateIDFilter = new FormControl();

  //loading spinner
  isLoading = true;
  checkLoadingDataSource: any;
  isLoading_package = true;
  checkLoadingDataSource_package: any;
  isLoading_itemCate = true;
  // checkLoadingDataSource_itemCate: any;

  searchValue = '';
  searchPackageValue = '';

  filteredValues = {
    itemID: '', itemDescAll: ''
  };

  packageFilteredValues = {
    packID: '', packDescAll: ''
  };
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild("searchInput") private searchInputElement: ElementRef;
  @ViewChild("searchPackageInput") private searchPackageInputElement: ElementRef;



  TAG = 'BillPaymentSearchItemPackageDialogComponent';


  @Input() isShowItem: boolean;
  @Input() isSelectPackage: boolean;
  @Input() positionCase: string;

  ngOnInit() {
    this.setDefaultLanguageString(AppComponent.usingLanguage);

    this.getAllData();
  }


  getAllData(): void {

      this.getItemCateData();


    this.isLoading_itemCate=false;
    this.isLoading = false;

  }


  getItemCateData() {
    //itemCate list
    var shopID = NavigationComponent.selectedShopID.toString();


      this.getAllItemCate(shopID);


  

    //filter by local

  }

  getShoppingCartItemCate(shopID:string){
   // this.itemCateList = [new tItemCateModel()];
    this.isLoading_itemCate = false;
    this.getItemCateByConditionShoppingCart(shopID);
  }

  getItemCateByConditionShoppingCart(shopID:string){
    this.tItemCateService.getItemCateByConditionShoppingCart(shopID, "N", "N").subscribe(data => {

      //loading spinner
      this.isLoading_itemCate = false;
      this.checkLoadingDataSource_package = data;

   //   this.itemCateList = data;

    //  if (this.itemCateList != null && this.itemCateList.length > 0) {
    //    this.SearchItemByItemCate(this.itemCateList[0]);

    //  }

    }, error => this.isLoading_itemCate = false);
  }

  getAllItemCate(shopID:string){
    this.SearchItemByItemCate(4);
    /*
    this.tItemCateService.getItemCateByCondition(shopID, "N", "N").subscribe(data => {

      //loading spinner
      this.isLoading_itemCate = false;
      this.checkLoadingDataSource_package = data;

      this.itemCateList = data;

      if (this.itemCateList != null && this.itemCateList.length > 0) {
        this.SearchItemByItemCate(this.itemCateList[0]);

      }

    }, error => this.isLoading_itemCate = false);*/
    
  }


  resetSearch() {
    this.searchValue = '';
    this.searchPackageValue = '';

    if (this.searchInputElement != null) {
      this.searchInputElement.nativeElement.focus();
    }

    if ((this.searchPackageInputElement != null)) {
      this.searchPackageInputElement.nativeElement.focus();

    }
  }


  selectTabEvent($event) {

    this.resetSearch();
  }



  setDefaultLanguageString(language: String) {

    this.unitItemService.getActiveDatas().subscribe(data => {
      this.itemUnitList = data;
    });

  }


  selectRow(selectedModel: tDishesModel, index: number) {
/*
    this.log.i(this.TAG, "selectRow = " + selectedModel.itemID.toString());

    const itemUnitStr = this.itemUnitList.find(p => p.itemUnitID === selectedModel.itemUnit).itemUnitName;


    this.log.i(this.TAG, itemUnitStr);

    this.selectedRowIndex = index;


    this.tItemService.shareSelected(selectedModel.itemID.toString(),
      selectedModel.itemDesc.toString(),
      itemUnitStr,
      selectedModel.standardPrice);
*/
//this.activeModal.close({ returnModel: "tMaterialModel", data: selectedModel });
    this.activeModal.close(selectedModel);
  }





  SearchItemByItemCate(id) {

    var shopID = NavigationComponent.selectedShopID.toString();
    var selectedItemCateID = id;

     this.log.i(this.TAG, "do SearchItemByItemCate itemCate id =" + selectedItemCateID);

    //select itemCate change color
    for (var p = 0; p < this.dishesCatList.length; p++) {
      var checkingItemCateID = this.dishesCatList[p].id;

      var targetElement = this.el.nativeElement.querySelector('#navList_' + checkingItemCateID);

      if (targetElement != null) {
        if (checkingItemCateID == selectedItemCateID) {
          targetElement.style.color = 'blue';
        } else {
          targetElement.style.color = 'black';

        }
      }

    }

    //spinner run
    this.isLoading = true;
    this.dataList=new Array();

    if(selectedItemCateID==1){
      this.pushDataLish(1001,4,"早餐","菠蘿咕嚕肉","","份",4);
      this.pushDataLish(1002,4,"早餐","豬潤麵","","份",4);
      this.pushDataLish(1003,4,"早餐","西多士紅豆冰","","份",4);
      this.pushDataLish(1004,4,"早餐","雞脾包","","份",4);
      this.pushDataLish(1005,4,"早餐","菠蘿油","","份",4);
      this.isLoading = false;
      this.dataSource = new MatTableDataSource<tDishesModel>(this.dataList);
      this.dataSource.paginator = this.paginator;
    }else if(selectedItemCateID==2){
    //  this.pushDataLish(3001,2,"蔬菜材料","三色椒","","個",4);
     // this.pushDataLish(3002,2,"蔬菜材料","洋蔥","","個",4);
      this.isLoading = false;
      this.dataSource = new MatTableDataSource<tDishesModel>(this.dataList);
      this.dataSource.paginator = this.paginator;
    }else if(selectedItemCateID==3){
    //  this.pushDataLish(4001,2,"雜貨","雞蛋","","隻",4);
    //  this.pushDataLish(4002,2,"雜貨","鹹蛋","","個",4);
    //  this.pushDataLish(4003,2,"雜貨","皮蛋","","個",4);
      this.isLoading = false;
      this.dataSource = new MatTableDataSource<tDishesModel>(this.dataList);
      this.dataSource.paginator = this.paginator;
    }else if(selectedItemCateID==4){
      this.pushDataLish(4001,4,"粥餐","明火白粥","","份",4);
      this.pushDataLish(4002,4,"粥餐","白粥水","","份",4);
      this.pushDataLish(4003,4,"粥餐","粟米粥","","份",4);
      this.pushDataLish(4004,4,"粥餐","冬菇粥","","份",4);
      this.pushDataLish(4005,4,"粥餐","雜菜粥","","份",4);
      this.pushDataLish(4006,4,"粥餐","皮蛋瘦肉粥","","份",4);
      this.pushDataLish(4007,4,"粥餐","菠菜雞絲粥","","份",4);
      this.pushDataLish(4008,4,"粥餐","瑤柱雜菜粥","","份",4);
      this.isLoading = false;
      this.dataSource = new MatTableDataSource<tDishesModel>(this.dataList);
      this.dataSource.paginator = this.paginator;
    }
    //get the item info
    /*
    this.tItemService.getItemListByItemCateID(shopID, selectedItemCateID).subscribe(data => {

      //loading spinner
      this.isLoading = false;
      this.checkLoadingDataSource = data;

    //  this.dataList = data;
      this.dataSource = new MatTableDataSource<tMaterialModel>(this.dataList);
      this.dataSource.paginator = this.paginator;




      this.resetSearch()



    },
      error => this.isLoading = false);*/
    

  }
  pushDataLish(ID,dishesCatID,dishesCatName,dishesDesc,dishesDescENG,unitDesc,unitID){
    var newData=new tDishesModel();
    newData.ID=ID;
    newData.dishesCatID=dishesCatID;
    newData.dishesDesc=dishesDesc;
    newData.dishesDescENG=dishesDescENG;
    newData.dishesCatName=dishesCatName;
    newData.unitDesc=unitDesc;
    newData.unitID=unitID;
    newData.shopID=1;
    newData.inActive="N";
    this.dataList.push(newData);
  }

  getItemUnitListName(id: number) {
    return this.itemUnitList.find(p => p.itemUnitID === id).itemUnitName;
  }

}
